if (!customElements.get('coffee-nomad-home')) {
  customElements.define('coffee-nomad-home', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const filters = this.querySelector('[data-ritual-filters]');
      const items = [...this.querySelectorAll('[data-product-ritual]')];
      if (filters && items.length) {
        filters.hidden = false;
        filters.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-ritual]');
          if (!button) return;
          const selected = button.dataset.ritual;
          let count = 0;
          items.forEach((item) => {
            const ritual = item.dataset.productRitual;
            const visible = selected === 'all' || selected === ritual || (ritual === 'both' && ['pour-over', 'espresso'].includes(selected));
            item.hidden = !visible;
            if (visible) count++;
          });
          filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          const status = this.querySelector('[data-filter-status]');
          if (status) status.textContent = status.dataset.countTemplate.replace('[count]', count).replace('[ritual]', button.textContent.trim());
        }, options);
      }
      const rail = this.querySelector('[data-category-rail]');
      const controls = this.querySelector('[data-rail-controls]');
      if (rail && controls) {
        controls.hidden = false;
        const previous = controls.querySelector('[data-rail-previous]');
        const next = controls.querySelector('[data-rail-next]');
        const update = () => {
          const overflow = rail.scrollWidth > rail.clientWidth + 2;
          previous.disabled = !overflow || rail.scrollLeft <= 1;
          next.disabled = !overflow || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
        };
        const scroll = (direction) => rail.scrollBy({ left: direction * rail.clientWidth * .78, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        previous.addEventListener('click', () => scroll(-1), options);
        next.addEventListener('click', () => scroll(1), options);
        rail.addEventListener('scroll', update, { ...options, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(rail);
        update();
      }
      const notes = [...this.querySelectorAll('.cn-brew-notes details')];
      notes.forEach((note) => note.addEventListener('toggle', () => {
        if (note.open) notes.forEach((other) => { if (other !== note) other.open = false; });
      }, options));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
  });
}
